import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';

export interface IMenuItem {
    id?: string;
    title?: string;
    description?: string;
    type: string;       // Possible values: link/dropDown/extLink
    name?: string;      // Used as display text for item and title for separator type
    state?: string;     // Router state
    icon?: string;      // Material icon name
    tooltip?: string;   // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
    active?: boolean;
}
export interface IChildItem {
    id?: string;
    parentId?: string;
    type?: string;
    name: string;       // Display text
    state?: string;     // Router state
    icon?: string;
    sub?: IChildItem[];
    active?: boolean;
}

interface IBadge {
    color: string;      // primary/accent/warn/hex color codes(#fff000)
    value: string;      // Display text
}

interface ISidebarState {
    sidenavOpen?: boolean;
    childnavOpen?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    public sidebarState: ISidebarState = {
        sidenavOpen: true,
        childnavOpen: false
    };
    selectedItem: IMenuItem;

    user_rol_id = localStorage.getItem('rol_id')
    
    constructor(
        private userService: UserService
    ) {
        this.userService.getMyRol().subscribe(data => {
            this.chooseMenu(data[0].id);
        })
    }

    defaultMenu: IMenuItem[] = [];

    adminMenu: IMenuItem[] = [
        {
            name: 'Simuladores',
            description: 'i-Windows-2',
            icon: 'i-Windows-2',
            type: 'dropDown',
            sub: [
                { icon: 'i-Windows-2', name: 'Arbitraje', state: '/calculadora/arbitraje', type: 'link' },
                { icon: 'i-Windows-2', name: 'Mercado Nacional', state: '/calculadora/national-market', type: 'link' },
                { icon: 'i-Windows-2', name: 'Mercado Internacional', state: '/calculadora/international-market', type: 'link' },
                { icon: 'i-Windows-2', name: 'Cuenta Propia', state: '/calculadora/own-account', type: 'link' },
            ]
        },

      
     
        // {
        //     name: 'Solicitudes',
        //     icon: 'i-Windows-2',
        //     type: 'link',
        //     state: '/requests'
        // },
        {
            name: 'Configuración',
            icon: 'i-Data-Settings',
            type: 'link',
            state: '/parameters'
        },
        {
            name: 'Usuarios',
            icon: 'i-Add-User',
            type: 'link',
            state: '/users'
        },
        {
            name: 'Solicitudes clientes',
            icon: 'i-Windows-2',
            type: 'link',
            state: '/requests/clients-requests'
        },
        

    ];

    exeMenu: IMenuItem[] = [
      

        {
            name: 'Solicitudes clientes',
            icon: 'i-Windows-2',
            type: 'link',
            state: '/requests/clients-requests'
        },

    ];

    managerMenu: IMenuItem[] = [
        {
            name: 'Simuladores',
            description: 'i-Windows-2',
            icon: 'i-Windows-2',
            type: 'dropDown',
            sub: [
                { icon: 'i-Windows-2', name: 'Arbitraje', state: '/calculadora/arbitration', type: 'link' },
                { icon: 'i-Windows-2', name: 'Mercado Nacional', state: '/calculadora/national-market', type: 'link' },
                { icon: 'i-Windows-2', name: 'Mercado Internacional', state: '/calculadora/international-market', type: 'link' },
                { icon: 'i-Windows-2', name: 'Cuenta Propia', state: '/calculadora/own-account', type: 'link' },
            ]
        },

      
        // {
        //     name: 'Solicitudes',
        //     icon: 'i-Windows-2',
        //     type: 'link',
        //     state: '/requests'
        // },
   
        

    ];
/*
    clientMenu: IMenuItem[] = [
        {
            name: 'Mi Solicitud',
            description: '',
            icon: 'i-File-Clipboard-File--Text',
            type: 'dropDown',
            sub: [
                { icon: 'i-File-Clipboard-File--Text', name: 'Mi Solicitud', state: '/customer', type: 'link' },
                { icon: 'i-Data-Settings', name: 'Información Adicional', state: '/intern-frm', type: 'link' },
                { icon: 'i-File-Clipboard-File--Text', name: 'Nueva Solicitud', state: '/customer/new-request', type: 'link' },
            ]
        },
        {
            name: 'Mi Perfil',
            icon: 'i-Administrator',
            type: 'link',
            state: '/my-profile'
        },
        {
            name: 'Términos y Condiciones',
            icon: 'i-Check',
            type: 'link',
            state: '/terms-conditions'
        },
        
        {
            name: 'Mi Cronograma',
            description: '',
            type: 'dropDown',
            icon: 'i-Calendar',
            sub: [
                { icon: 'i-Calendar', name: 'Todos', state: '/cronograma-de-pagos', type: 'link' },
                { icon: 'i-Calendar', name: 'Pendientes', state: '/cronograma-de-pagos/pendientes', type: 'link' },
                { icon: 'i-Calendar', name: 'Pagados', state: '/cronograma-de-pagos/pagados', type: 'link' },
            ]
        },

    ];*/
    
    // sets iconMenu as default;
    menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
    // navigation component has subscribed to this Observable
    menuItems$ = this.menuItems.asObservable();

    chooseMenu(rol){
        switch (rol){
            case 1: //ADMIN
                this.menuItems.next(this.adminMenu);
                break;
            case 2:   //EJEUTIVO
                this.menuItems.next(this.exeMenu);
                break;
            case 3:  //GERENTE 
                  this.menuItems.next(this.managerMenu);
                 break;
                

        }
        
    }

    // You can customize this method to supply different menu for
    // different user type.
    publishNavigationChange(userType: string) {
      switch (userType) {
        case 'admin':
          this.menuItems.next(this.adminMenu);
          break;
      
          break;
        default:
          this.menuItems.next(this.defaultMenu);
      }
    }
}
